import PropTypes from 'prop-types';
import React from 'react';

import './WidgetTitle.scss';

const WidgetTitle = ({
  children,
  horizontalRule,
  text,
  role,
}) => (
  <div className="WidgetTitle">
    <h1 role={role}>{text || children}</h1>
    {horizontalRule && <hr />}
  </div>
);

WidgetTitle.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(
      PropTypes.element
    ),
  ]),
  horizontalRule: PropTypes.bool,
  text: PropTypes.string,
  role: PropTypes.string,
};

WidgetTitle.defaultProps = {
  children: null,
  horizontalRule: true,
  text: '',
  role: undefined,
};

export default WidgetTitle;
